import { render, staticRenderFns } from "./VDeals.vue?vue&type=template&id=f85f48a0&"
import script from "./VDeals.vue?vue&type=script&lang=js&"
export * from "./VDeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f85f48a0')) {
      api.createRecord('f85f48a0', component.options)
    } else {
      api.reload('f85f48a0', component.options)
    }
    module.hot.accept("./VDeals.vue?vue&type=template&id=f85f48a0&", function () {
      api.rerender('f85f48a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VDeals/VDeals.vue"
export default component.exports